import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const removeFromGroup = createAsyncThunk<
  void,
  { groupId: string; telegramIds: number[] },
  { state: RootState }
>('groups/removeMembers', async (params, thunkApi) => {
  const { dispatch } = thunkApi;
  const updatedGroup = await groupsService.removeFromGroup({
    groupId: params.groupId,
    telegramIds: params.telegramIds,
  });
  dispatch(entitiesActions.upsertGroup(updatedGroup));
});
